import { userPermission } from "../../routes/oauthRoutes";
import SiteAdminAppList from "./SiteAdmin";
import SystemAdminAppList from "./SystemAdmin";
import UserManagerAppList from "./UserManager";

const ApplicationList = ({ user }: any) => {
    if (user) {
        const auth = userPermission(user);

        return auth.superAdmin ? (
            <SystemAdminAppList />
        ) : auth.userManager ? (
            <UserManagerAppList auth={auth} />
        ) : auth.siteAdmin ? (
            <SiteAdminAppList auth={auth} />
        ) : (
            "Not an user"
        );
    }
};

export default ApplicationList;
